var _jsxFileName = "/Users/vincent.limshowchen/Sites/account-components/src/components/Register/RegistrationForm.js";
import React, { useRef, useMemo } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Popover from "@mlb/react-patterns/dist/components/Popover/popover";
import Prompt from "./Prompt";
var RegistrationForm = function RegistrationForm(props) {
  var passwordInputRef = useRef();
  var backButtonClicked = props.backButtonClicked,
    handleSubmit = props.handleSubmit,
    handleFieldChange = props.handleFieldChange,
    birthdayDisabled = props.birthdayDisabled,
    handleFocus = props.handleFocus,
    emailDisabled = props.emailDisabled,
    isEU = props.isEU,
    copyConfig = props.copyConfig,
    popoverOffset = props.popoverOffset,
    popoverPosition = props.popoverPosition,
    showOptinCheckbox = props.showOptinCheckbox,
    showPolicy = props.showPolicy,
    registerState = props.registerState,
    stacked = props.stacked;
  var inputPrompt = registerState.inputPrompt,
    errorMessage = registerState.errorMessage,
    showError = registerState.showError,
    inputs = registerState.inputs;
  var email = inputs.email,
    emailValid = inputs.emailValid,
    passwordValid = inputs.passwordValid,
    confirmPasswordValid = inputs.confirmPasswordValid,
    months = inputs.months,
    monthsValid = inputs.monthsValid,
    days = inputs.days,
    daysValid = inputs.daysValid,
    years = inputs.years,
    yearsValid = inputs.yearsValid,
    optInChecked = inputs.optInChecked,
    euTosPriv = inputs.euTosPriv;
  var widgetHeader = copyConfig.widgetHeader,
    emailPlaceholder = copyConfig.emailPlaceholder,
    passwordPlaceholder = copyConfig.passwordPlaceholder,
    confirmPasswordPlaceholder = copyConfig.confirmPasswordPlaceholder,
    birthdayLabel = copyConfig.birthdayLabel,
    monthPlaceholder = copyConfig.monthPlaceholder,
    dayPlaceholder = copyConfig.dayPlaceholder,
    yearPlaceholder = copyConfig.yearPlaceholder,
    optInLabel = copyConfig.optInLabel,
    policyLabel = copyConfig.policyLabel,
    submitButton = copyConfig.submitButton,
    loginLabel = copyConfig.loginLabel,
    loginLink = copyConfig.loginLink;
  var tosUrl = "https://www.mlb.com/official-information/terms-of-use";
  var policyUrl = "https://www.mlb.com/official-information/privacy-policy";
  var euPolicyLabel = "I agree to the <a href=".concat(tosUrl, " target=\"_blank\">Terms of Use</a> and <a href=").concat(policyUrl, " target=\"_blank\">Privacy Policy</a><span className=\"connect__req-text\"> (required)</span>");
  var renderTermsAndPolicy = function renderTermsAndPolicy(position) {
    if (isEU && position === "top") {
      return /*#__PURE__*/React.createElement("div", {
        className: "connect__input-optin",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 65,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "eu-tos-priv",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 66,
          columnNumber: 11
        }
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        name: "eu-tos-priv",
        id: "eu-tos-priv",
        checked: euTosPriv,
        onChange: function onChange() {
          return handleFieldChange("euTosPriv", !euTosPriv);
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 67,
          columnNumber: 13
        }
      }), /*#__PURE__*/React.createElement("span", {
        className: "connect__input-optin-label",
        dangerouslySetInnerHTML: {
          __html: euPolicyLabel
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 74,
          columnNumber: 13
        }
      })), /*#__PURE__*/React.createElement("p", {
        className: "connect__policy-print",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 81,
          columnNumber: 11
        }
      }, "By agreeing to any of the above terms, you are agreeing that your personal information will be collected, stored and processed in the United States on behalf of MLB. We provide appropriate security to your personal information. You can opt out of receiving communications at any time, all pursuant to the", " ", /*#__PURE__*/React.createElement("a", {
        href: policyUrl,
        target: "_blank",
        rel: "nofollow noopener noreferrer",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 87,
          columnNumber: 13
        }
      }, "Privacy Policy"), ". You can request the modification or deletion of your personal information from MLBs records at any time. You can request a copy of your personal information held by MLB at any time. Should you have any complaints about our use and storage of your personal information, you can direct them to your countrys data protection authority. If you have any questions, please contact us by postal mail at MLB Advanced Media, 75 Ninth Avenue, 5th Floor, New York, NY 10011 USA, or by email at", /*#__PURE__*/React.createElement("a", {
        href: "mailto:privacy@website.mlb.com",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 102,
          columnNumber: 13
        }
      }, " ", "privacy@website.mlb.com"), ". More details about our privacy practices are available in the", " ", /*#__PURE__*/React.createElement("a", {
        href: tosUrl,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 107,
          columnNumber: 13
        }
      }, "Terms of Use"), " and", " ", /*#__PURE__*/React.createElement("a", {
        href: policyUrl,
        target: "_blank",
        rel: "nofollow noopener noreferrer",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 108,
          columnNumber: 13
        }
      }, "Privacy Policy"), "."), /*#__PURE__*/React.createElement("p", {
        className: "connect__policy-print",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 117,
          columnNumber: 11
        }
      }, "The Major League Baseball companies are: the Office of the Commissioner of Baseball, MLB Advanced Media, L.P., MLB Properties, Inc. and The MLB Network, LLC"));
    } else if (!isEU && position === "bottom") {
      return /*#__PURE__*/React.createElement("div", {
        className: "connect__policy",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 126,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "connect__policy-text",
        dangerouslySetInnerHTML: {
          __html: policyLabel
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 127,
          columnNumber: 11
        }
      }));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  };
  var renderSubmitButton = function renderSubmitButton() {
    if (isEU) {
      return /*#__PURE__*/React.createElement("div", {
        className: "connect__button p-button",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 140,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement("button", {
        className: "button-primary",
        onClick: handleSubmit,
        disabled: !euTosPriv,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 141,
          columnNumber: 11
        }
      }, submitButton));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "connect__button p-button",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 152,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement("button", {
      className: "p-button__button button-primary",
      onClick: handleSubmit,
      disabled: false,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 153,
        columnNumber: 9
      }
    }, submitButton));
  };
  var promptElement = useMemo(function () {
    return /*#__PURE__*/React.createElement(Prompt, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 164,
        columnNumber: 39
      }
    });
  }, []);
  var renderPasswordInputGroup = function renderPasswordInputGroup(stacked) {
    return /*#__PURE__*/React.createElement("div", {
      className: classnames({
        "connect__input-group": true,
        // eslint-disable-line
        stacked: stacked === true
      }),
      __source: {
        fileName: _jsxFileName,
        lineNumber: 168,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames({
        "connect__inline-group": stacked === false // eslint-disable-line
      }),
      __source: {
        fileName: _jsxFileName,
        lineNumber: 174,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement("input", {
      className: classnames({
        connect__input: true,
        // eslint-disable-line
        "connect__input--invalid": passwordValid === false,
        "connect__input--valid": passwordValid === true
      }),
      type: "password",
      placeholder: passwordPlaceholder,
      ref: passwordInputRef,
      onBlur: function onBlur(e) {
        return handleFieldChange("password", e.target.value);
      },
      onFocus: function onFocus() {
        return handleFocus("password");
      },
      suppressHydrationWarning: true,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 179,
        columnNumber: 11
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "connect__input--password-prompt",
      __source: {
        fileName: _jsxFileName,
        lineNumber: 193,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement(Popover, {
      placement: popoverPosition,
      popoverOffset: popoverOffset,
      popoverContent: promptElement,
      referenceElement: passwordInputRef,
      isOpen: inputPrompt,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 194,
        columnNumber: 13
      }
    })), /*#__PURE__*/React.createElement("input", {
      className: classnames({
        connect__input: true,
        // eslint-disable-line
        "connect__input--invalid": confirmPasswordValid === false,
        "connect__input--valid": confirmPasswordValid === true
      }),
      type: "password",
      placeholder: confirmPasswordPlaceholder,
      onBlur: function onBlur(e) {
        return handleFieldChange("confirmPassword", e.target.value);
      },
      onFocus: function onFocus() {
        return handleFocus("confirmPassword");
      },
      suppressHydrationWarning: true,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 203,
        columnNumber: 11
      }
    })));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "connect__registration-form",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 221,
      columnNumber: 5
    }
  }, widgetHeader && /*#__PURE__*/React.createElement("h1", {
    className: "connect__heading",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 222,
      columnNumber: 24
    }
  }, widgetHeader), /*#__PURE__*/React.createElement("div", {
    className: "connect__input-group",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 223,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("input", {
    className: classnames({
      connect__input: true,
      // eslint-disable-line
      "connect__input--invalid": emailValid === false,
      "connect__input--valid": emailValid === true
    }),
    type: "text",
    placeholder: emailPlaceholder,
    defaultValue: email,
    onBlur: function onBlur(e) {
      return handleFieldChange("email", e.target.value);
    },
    onFocus: function onFocus() {
      return handleFocus("email");
    },
    disabled: emailDisabled,
    suppressHydrationWarning: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 224,
      columnNumber: 9
    }
  })), stacked && renderPasswordInputGroup(true), /*#__PURE__*/React.createElement("div", {
    className: "connect__input-group",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 240,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "connect__input-label",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 241,
      columnNumber: 9
    }
  }, birthdayLabel), /*#__PURE__*/React.createElement("div", {
    className: "connect__inline-group",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 242,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("input", {
    className: classnames({
      connect__input: true,
      // eslint-disable-line
      "connect__input--month": true,
      "connect__input--invalid": monthsValid === false,
      "connect__input--valid": monthsValid === true
    }),
    type: "text",
    placeholder: monthPlaceholder,
    maxLength: 2,
    onBlur: function onBlur(e) {
      return handleFieldChange("months", e.target.value);
    },
    defaultValue: months,
    disabled: birthdayDisabled,
    suppressHydrationWarning: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 243,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement("input", {
    className: classnames({
      connect__input: true,
      // eslint-disable-line
      "connect__input--day": true,
      "connect__input--invalid": daysValid === false,
      "connect__input--valid": daysValid === true
    }),
    type: "text",
    placeholder: dayPlaceholder,
    maxLength: 2,
    onBlur: function onBlur(e) {
      return handleFieldChange("days", e.target.value);
    },
    defaultValue: days,
    disabled: birthdayDisabled,
    suppressHydrationWarning: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 258,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement("input", {
    className: classnames({
      connect__input: true,
      // eslint-disable-line
      "connect__input--year": true,
      "connect__input--invalid": yearsValid === false,
      "connect__input--valid": yearsValid === true
    }),
    type: "text",
    placeholder: yearPlaceholder,
    maxLength: 4,
    onBlur: function onBlur(e) {
      return handleFieldChange("years", e.target.value);
    },
    defaultValue: years,
    disabled: birthdayDisabled,
    suppressHydrationWarning: true,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 273,
      columnNumber: 11
    }
  }))), !stacked && renderPasswordInputGroup(false), showOptinCheckbox && !isEU && /*#__PURE__*/React.createElement("div", {
    className: "connect__input-optin",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 292,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "optin",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 293,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement("input", {
    name: "optin",
    type: "checkbox",
    suppressHydrationWarning: true,
    checked: optInChecked,
    onChange: function onChange() {
      return handleFieldChange("optInChecked", !optInChecked);
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 294,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "connect__input-optin-label",
    dangerouslySetInnerHTML: {
      __html: optInLabel
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 301,
      columnNumber: 13
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "connect__print",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 308,
      columnNumber: 7
    }
  }, renderTermsAndPolicy("top"), renderSubmitButton()), /*#__PURE__*/React.createElement("div", {
    className: "connect__login-back",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 312,
      columnNumber: 7
    }
  }, loginLabel, /*#__PURE__*/React.createElement("button", {
    className: "back-to",
    onClick: backButtonClicked,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 314,
      columnNumber: 9
    }
  }, loginLink)), showPolicy && renderTermsAndPolicy("bottom"), /*#__PURE__*/React.createElement("div", {
    className: "connect__alert",
    style: {
      visibility: showError ? "visible" : "hidden"
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 319,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "connect__alert-message",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 325,
      columnNumber: 9
    }
  }, errorMessage)));
};
RegistrationForm.propTypes = {
  handleSubmit: PropTypes.func,
  handleFieldChange: PropTypes.func,
  emailValid: PropTypes.bool,
  passwordValid: PropTypes.bool,
  confirmPasswordValid: PropTypes.bool,
  monthsValid: PropTypes.bool,
  daysValid: PropTypes.bool,
  yearsValid: PropTypes.bool,
  inputPrompt: PropTypes.bool,
  popoverOffset: PropTypes.arrayOf(PropTypes.number),
  popoverPosition: PropTypes.string,
  handleFocus: PropTypes.func,
  optin: PropTypes.bool,
  isEU: PropTypes.bool,
  euOptin: PropTypes.bool,
  euTosPriv: PropTypes.bool,
  stacked: PropTypes.bool
};
RegistrationForm.defaultProps = {
  handleSubmit: function handleSubmit() {},
  handleFieldChange: function handleFieldChange() {},
  emailValid: null,
  passwordValid: null,
  confirmPasswordValid: null,
  monthsValid: null,
  daysValid: null,
  yearsValid: null,
  inputPrompt: false,
  popoverPosition: "top",
  popoverOffset: [0, 10],
  handleFocus: function handleFocus() {},
  optin: false,
  isEU: false,
  euOptin: false,
  euTosPriv: true,
  stacked: false
};
export default RegistrationForm;